var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Spin } from 'antd';
import { MyForm, MyInput } from '../../../../../Base/Form';
import LoginMethodWithTitle from '../../../LoginMethodWithTitle';
import PasswordResetIcon from '../../../../../../assets/icons/auth/password-hidden-icon.svg';
import { useStore } from '../../../../../../store/rootStore';
import LoginLayout from '../../../LoginLayout';
import s from '../../../../Login.module.scss';
const ResetPassword = observer(() => {
    const { loginStore } = useStore();
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState();
    const [confirmPasswordError, setConfirmPasswordError] = useState();
    const [isInitializing, setIsInitializing] = useState(true);
    const [hasRecoverySession, setHasRecoverySession] = useState(false);
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    const uid = searchParams.get('uid');
    useEffect(() => {
        const initializeSession = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                // If token and uid are present, login with reset token
                if (token && uid) {
                    yield loginStore.loginWithResetToken(token, uid);
                    setHasRecoverySession(true);
                    history.replace('/reset-password');
                    return;
                }
                // No token in URL, check if we have an existing recovery session
                const hasSession = yield loginStore.checkRecoverySession();
                if (hasSession) {
                    setHasRecoverySession(true);
                }
                else {
                    history.replace('/forgot-password');
                }
            }
            catch (err) {
                setError((err === null || err === void 0 ? void 0 : err.message) || t('invalidOrExpiredResetLink'));
            }
            finally {
                setIsInitializing(false);
            }
        });
        initializeSession();
    }, [token, uid]);
    const handlePasswordChange = (value) => {
        setNewPassword(value);
    };
    const handleConfirmPasswordChange = (value) => {
        setConfirmPassword(value);
        setConfirmPasswordError(undefined);
    };
    const handleConfirmPasswordBlur = () => {
        if (confirmPassword && newPassword !== confirmPassword) {
            setConfirmPasswordError(t('passwordsDoNotMatch'));
        }
    };
    const handleSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        setError(undefined);
        if (newPassword !== confirmPassword) {
            setConfirmPasswordError(t('passwordsDoNotMatch'));
            return;
        }
        try {
            yield loginStore.updatePasswordWithRecoverySession(newPassword);
            history.replace('/');
        }
        catch (err) {
            console.error('Password update error:', err);
            setError(err.message || 'Failed to update password');
        }
    });
    const disabled = !newPassword || !confirmPassword || loginStore.loading;
    if (isInitializing) {
        return (React.createElement(LoginLayout, null,
            React.createElement("div", { className: s.pageWrapper },
                React.createElement(LoginMethodWithTitle, { title: React.createElement(Trans, { i18nKey: "validatingResetLink" }), icon: PasswordResetIcon },
                    React.createElement(Spin, { size: "large" })))));
    }
    if (error && !hasRecoverySession) {
        return (React.createElement(LoginLayout, { errorMessage: error },
            React.createElement("div", { className: s.pageWrapper },
                React.createElement(LoginMethodWithTitle, { title: React.createElement(Trans, { i18nKey: "resetPasswordFailed" }), description: error, icon: PasswordResetIcon },
                    React.createElement("button", { className: s.backToLoginLink, onClick: () => history.push('/login') },
                        React.createElement(Trans, { i18nKey: "backToLogin" }))))));
    }
    return (React.createElement(LoginLayout, { errorMessage: error },
        React.createElement("div", { className: s.pageWrapper },
            React.createElement(LoginMethodWithTitle, { title: React.createElement(Trans, { i18nKey: "setNewPassword" }), description: React.createElement(Trans, { i18nKey: "setNewPasswordDescription" }), icon: PasswordResetIcon },
                React.createElement(MyForm, { onSubmit: handleSubmit, loading: loginStore.loading, disabled: disabled, submitButtonText: "resetPasswordAndLogin" },
                    React.createElement(MyInput.Password, { key: "newPassword", id: "newPassword", name: "newPassword", type: "password", placeholder: t('newPassword'), labelKey: "newPassword", value: newPassword, onChangeHandler: handlePasswordChange, className: s.input }),
                    React.createElement(MyInput.Password, { key: "confirmPassword", id: "confirmPassword", name: "confirmPassword", type: "password", placeholder: t('confirmPassword'), labelKey: "confirmPassword", value: confirmPassword, onChangeHandler: handleConfirmPasswordChange, onBlur: handleConfirmPasswordBlur, className: s.input, error: confirmPasswordError }))))));
});
export default ResetPassword;
